module.exports = {
  colors: {
    white: '#FFF',
    black: {
      150: '#EAEAEA',
      200: '#E2E2E2',
      600: '#9a9897',
      700: '#83807f',
      1000: '#000',
    },
    beige: {
      100: '#FCF9F7',
      200: '#F9F2EF',
    },
    red: {
      100: '#FFF3ED',
      200: '#FFE7DA',
      400: '#FFBDA7',
      600: '#FF573E',
    },
    yellow: {
      100: '#FFF6D1',
      200: '#FFECA4',
      400: '#FFE78D',
      600: '#FFCB03',
    },
    blue: {
      100: '#F4F6FB',
      150: '#E9EDF7',
      200: '#DFE4F3',
      400: '#B0C5F1',
      600: '#3C71DA',
      800: '#305AAE',
    },
    green: {
      100: '#F2F9F2',
      200: '#D3ECD3',
      600: '#5EA237',
    },
    transparent: 'transparent',
    inherit: 'inherit',
    overlay: 'rgba(60, 113, 218, 0.15)',
  },

  fontFamily: {
    title: 'lf-antique-olive',
    body: 'lf-aktiv-grotesk',
  },
  extend: {
    boxShadow: {
      dropdown: '0px 2px 16px 0px #0000001A',
      sidePanel: '0 2px 9px 0 rgba(0, 0, 0, 0.25)',
    },
  },
};
